/**
 * A global array of possible `ParentNode`.
 */
const parentNodes = [Document, Element, HTMLElement];
export default parentNodes;
